import { Alert } from "react-bootstrap";

/**
 * Props for the AnnotationPreview component.
 */
interface AnnotationPreviewProps {
  previewText: string;
}

/**
 * Display a human-readable preview of the current annotation logic.
 *
 * @param props - Destructured parameter object
 * @param props.previewText - Preview text to display
 */
export const AnnotationPreview = ({ previewText }: AnnotationPreviewProps): React.ReactElement => {
  const isEmpty = !previewText || previewText === "No annotation clauses configured";

  return (
    <div>
      <h6 className="mb-2">
        <strong>Annotation Preview</strong>
      </h6>
      <Alert
        variant={isEmpty ? "light" : "info"}
        className="mb-3"
      >
        {isEmpty ? (
          <em className="text-muted">Complete the annotation expression to see preview</em>
        ) : (
          previewText
        )}
      </Alert>
    </div>
  );
};

AnnotationPreview.displayName = "AnnotationPreview";
